module.exports = __webpack_public_path__ + "img/51cbad6.jpg";